<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Scale</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn  small text to="/scales">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      
      <v-card-text>
        <!-- editor -->
        <editor :docCreate="docCreate" :initial="dataItem" @data="save"></editor>
        <!-- end -->
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
    storeSpecific: ""
  }),
  methods: {
    save(data) {
      const url = "/scales";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/scales");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {

  }
};
</script>